import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    name: '指标算法',
    type: 'AMAI_IALG',
    mapProp: 'map',
}